import styled from "styled-components";
import { darken } from "polished";

export const Container = styled.div`
  display: ${(props) => (props.active ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

export const AreaNoClick = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  background-color: #fff;
  max-width: 90%;
  height: ${(props) =>
    props.small ? "auto" : props.large ? "40rem" : "30rem"};
  width: ${(props) => (props.small ? "auto" : "50rem")};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 10002;

  > main {
    width: 100%;
    height: 100%;

    padding: 1rem;
    display: flex;
    list-style: none;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    li {
      width: 100%;
      height: 100%;
      display: flex;
      list-style: none;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;

      input {
        margin-top: 0.5rem;
        padding: 0.5rem;
        border-radius: 5px;
      }
    }
  }

  @keyframes slideBoxFormUp {
    from {
      margin-bottom: -35%;
    }
    to {
      margin-bottom: 0px;
    }
  }
  animation: 0.2s ease-out 0s 1 slideBoxFormUp;

  @media screen and (max-width: 800px) {
    height: ${(props) => (props.small ? "auto" : "80%")};
  }
`;

export const ModalButton = styled.button`
  margin-top: ${(props) => (props.column ? "1rem" : "0")};
  margin-left: ${(props) => (props.row ? "1rem" : "0")};
  background-color: ${(props) => props.color};
  color: #fff;
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: var(--transition);
  cursor: pointer;

  i {
    width: 2.5rem;
    padding: 0.5rem;
    border-radius: ${(props) =>
      props.reverse
        ? "0 var(--border-radius) var(--border-radius) 0"
        : "var(--border-radius) 0 0 var(--border-radius)"};
    background: ${(props) => darken("0.1", props.color)};
    transition: var(--transition);
  }

  span {
    font-weight: 500;
    padding: 0.6rem;
    width: 100%;
    text-align: left;
    font-size: var(--font-text-size);
  }

  &:hover {
    i {
      background-color: ${(props) => darken("0.2", props.color)};
    }

    background-color: ${(props) => darken("0.1", props.color)};
  }

  &:first-of-type {
    margin-top: 0;
    margin-left: 0;
  }
`;
